import { render, staticRenderFns } from "./BaseLottie.vue?vue&type=template&id=4acb5284&"
import script from "./BaseLottie.vue?vue&type=script&lang=js&"
export * from "./BaseLottie.vue?vue&type=script&lang=js&"
import style0 from "./BaseLottie.vue?vue&type=style&index=0&id=4acb5284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports